/**
 * The Kitchen PWA ("Chain29 Kitchen"; kds.<domain>, /kds, /pwa/kds): the ONE
 * kitchen screen (apps/dining/screens/KDSScreen) under the restaurant-account
 * sign-in (apps/kds/KitchenPwa). docs/DINING_API_2026-10-28.md §11 / §14.
 */
import React from 'react';
import { ChefHat } from 'lucide-react';
import KDSScreen from '@/apps/dining/screens/KDSScreen';
import KitchenPwa from './KitchenPwa';

export default function KDSApp() {
  return <KitchenPwa app="kds" appName="Kitchen Display" icon={ChefHat} accent="#f97316" Screen={KDSScreen} what="kitchen" />;
}
